import 'flatpickr/dist/flatpickr.min.css';
import { ToastContainer } from "react-toastify";
import React, { useReducer } from "react";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { DndProvider } from "react-dnd";
import { HTML5Backend } from "react-dnd-html5-backend";
import ReactDOM from "react-dom/client";
import { BrowserRouter as Router } from "react-router-dom";
import * as Sentry from "@sentry/react";

import ThemeProvider from "./utils/ThemeContext";
import App from "./App";
import { AuthContext, authInitialState, authReducer } from "store/auth/AuthContext";
import { useAdminMe } from "api/hooks";
import { SignInPage } from "pages/SignInPage";

// Sentry.init({
//   dsn: "https://994c9214a9a21c26bc9ad426b2c3e97b@o4507939776692224.ingest.de.sentry.io/4507939779969104",
//   integrations: [Sentry.browserTracingIntegration(), Sentry.replayIntegration()],
//   // Tracing
//   tracesSampleRate: 1.0, //  Capture 100% of the transactions
//   // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
//   tracePropagationTargets: ["localhost", /^beta-szkolenia-gw.netlify.app/, /^api.corgisoftware.pl/],
//   // Session Replay
//   replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
//   replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
// });
export const queryClient = new QueryClient();
const AuthGate = () => {
  const { me, loaded } = useAdminMe();
  if (!loaded) return null;
  const isAuthenticated = Boolean(me?.email);

  if (!isAuthenticated) return <SignInPage />;
  return <App />;
};

const Main = () => {
  const [state, dispatch] = useReducer(authReducer, authInitialState);

  return (
    <DndProvider backend={HTML5Backend}>
      <QueryClientProvider client={queryClient}>
        <AuthContext.Provider value={{ state, dispatch }}>
          <Router>
            <ThemeProvider>
              <AuthGate />
              <ToastContainer />
            </ThemeProvider>
          </Router>
        </AuthContext.Provider>
      </QueryClientProvider>
    </DndProvider>
  );
};
ReactDOM.createRoot(document.getElementById("root") as HTMLElement).render(<Main />);
